<template>
	<v-btn-toggle
		:value="value"
		mandatory
		borderless
		dense
		class="toggle-button-group"
		@change="$emit('change', $event)"
	>
		<v-btn
			v-for="item in items"
			:key="String(item.id)"
			:value="item.id"
			:outlined="item.id !== value"
			:color="item.id === value ? 'primary' : ''"
			class="rounded-xl flex-grow-1"
		>
			{{ item.name }}
		</v-btn>
	</v-btn-toggle>
</template>

<script>
export default {
	name: 'ToggleButtonGroup',
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: [String, Number, Boolean],
			default: null
		},
		items: {
			type: Array,
			required: true
		}
	}
}
</script>

<style scoped>
.toggle-button-group {
	display: flex;
	width: 100%;
	gap: 8px;
}
</style>
